module.exports = __webpack_public_path__ + "img/epico.03df841e.svg";